import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";

import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import * as uuidV4 from "uuid/v4";

import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

class TaskCreate extends Component {

  protected ref: any;

  public state = {
    instructions: "",
    reporterId: this.props?.app?.session?.user?.id,
    executionDate: null,
    amazonFolderName:  uuidV4(),
    finished: false
  };

  constructor(public props) {
    super(props);
  }

  public cancel = () => {
    this.props.onCancel.call(this);
  }

  public focusInput(): any {
    this.ref.focus();
  }

  public setTaskName = (event) => {
    const name = event.target.value;

    this.setState({
      instructions: name
    });
  }

  public selectReporter = (person: PersonInterface): void => {
    this.setState({
      reporterId: person.id
    });
  }

  public clearReporter = (): void => {
    this.setState({
      reporterId: null
    });
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date,
      finished: date === null ? true : this.state.finished
    });
  }

  public changeFinished = () => {
    this.setState({
      finished: !this.state.finished,
      executionDate: new Date()
    })
  }

  public create = (): void => {
    this.props.createTask({
      ...this.state
    });
  }

  public render() {
    return (
      <div className="note-form-container create" style={{borderBottom: "1px solid rgba(0, 0, 0, 0.1)"}}>
        <div style={{marginTop: "-10px"}}>
          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-name"
            type="text"
            inputProps={{ref: input => this.ref = input}}
            label={this.trans("label-description")}
            value={this.state.instructions}
            onChange={this.setTaskName}
            autoFocus={true}
            variant="standard"
            multiline
            rowsMax="25"
            rows="1"
            style={{marginBottom: "10px"}}
            error={!!this.getErrorFor("name")}
          />
          {!!this.getErrorFor("name") && <div className="component-error-text">{this.getDetailErrorFor("name")}</div>}
        </div>

        <PersonLookup
          {...this.props}
          autoSelectId={this.state.reporterId}
          isInlineBlock={true}
          width="100%"
          containerWidth="100%"
          ref="PersonLookup"
          floatingLabelText={this.trans("reported-by") + this.trans("field/optional")}
          labelText={this.trans("reported-by") + this.trans("field/optional")}
          onSelect={this.selectReporter}
          onClear={this.clearReporter}
          forceUpdatePage={true}
          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "taskCreate", "reporter")}
          buttonLabel={this.trans("button-add-person")}
          noResultText={this.trans("dropdown-person-notfound")}
          templateFor={"person"}
          includeUsers={true}
          hideClickThroughLink={true}
        />

        {
          !this.state.finished && (
            <DatePickerComponent
              {...this.props}
              className="scroll-to-executionDate"
              label={this.trans("show-me-from") + this.trans("field/optional")}
              initialDate={this.state.executionDate}
              onChange={date => this.selectDate(date, "executionDate")}
              minDate={new Date()}
              minDatePlusDays={0}
              clearButton={true}
              error={this.getErrorFor("executionDate")}
            />
          )
        }

        {
          this.state.finished && (
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.finished}
                  onChange={this.changeFinished}
                  color="primary"
                />
                }
              label={this.trans("status-finished")}
            />
          )
        }

        <div className="buttons task-buttons" style={{width: "100%", display: "flex", justifyContent: "flex-end", marginTop: "10px"}}>
          <Button
            color="primary"
            onClick={() => {
              this.props.dispatch({
                type: Constants.GLOBAL_EVENT_CREATE_CLEAR
              })

              this.setState({
                instructions: "",
                reporterId: this.props.unit ? this.props.unit?.getActiveContract?.()?.person?.id : null,
                executionDate: new Date(),
                amazonFolderName:  uuidV4(),
              }, this.cancel)}}
            className={"full-size"}
            style={{marginRight: "10px"}}
          >
            {this.trans("button-cancel")}
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={this.create}
            className={"full-size"}
          >
            {this.trans("button-add")}
          </Button>
        </div>
      </div>
    );
  }
}

export { TaskCreate };
